/* eslint-disable react/jsx-props-no-spreading */
import { Modal } from 'antd';
import styled from 'styled-components';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ModalBody = styled((props: any) => <Modal {...props} />)((props: any) => ({
	'&.ant-modal': {
		top: props.marginTop ? props.marginTop : '100px'
	},
	'& .ant-modal-content': {
		borderRadius: '10px',
		borderColor: '#799acb',
		borderWidth: '1px',
		fontSize: '14px',
		fontFamily: 'Poppins',
		backgroundColor: props.bgColor ? props.bgColor : '' // Aquí se añade el color de fondo
	},
	'& .ant-modal-title': {
		color: '#013e9e',
		fontSize: '20px',
		width: props.widthTitle ? props.widthTitle : '350px',
		fontWeight: 700
	},
	'& .ant-modal-header': {
		borderRadius: '10px',
		borderBottom: '0px solid #999999',
		backgroundColor: props.bgColor ? props.bgColor : '' // Aquí se añade el color de fondo
	},
	'& .ant-modal-body': {
		paddingTop: '0px',
		borderTop: '0px solid #999999'
	},
	'& .ant-modal-footer': {
		padding: props.noFooter ? '0px' : '10px 16px',
		border: '0px solid #fff'
	},
	'& .ant-modal-close-x': {
		width: '0px',
		height: '0px'
	}
}));

export const ModalButton = styled.button<{ buttonType?: string; secondary?: boolean; isDisabled?: boolean }>`
	border-radius: 24px;
	border-width: 1px;
	border-color: ${({ secondary }) => (secondary ? '#013E9E' : '#FD8B26')};
	color: ${({ buttonType, secondary, isDisabled }) =>
		isDisabled ? 'white' : buttonType === 'confirm' ? 'white' : secondary ? '#013E9E' : '#FD8B26'};
	padding: 6px 16px 6px 14px;
	background-color: ${({ buttonType, secondary, isDisabled }) =>
		isDisabled ? 'grey' : buttonType === 'confirm' ? (secondary ? '#013E9E' : '#FD8B26') : 'white'};
	margin: 0px 7px 0px 7px;

	transition: background 0.2s, color 0.2s;
`;
